/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Placeholder_PasswordInputs */



/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Login_Placeholder_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_placeholder_password = /** @type {((inputs?: Login_Placeholder_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Placeholder_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez votre mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese su contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite sua senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la tua password")
	return /** @type {LocalizedString} */ ("Enter your password")
});